<template>
  <div class="myService">
    <div class="main">
      <div class="question">
        <div class="pop_question">
          <div class="title">热门问题</div>
          <div class="pop_list">
            <ul>
              <li v-for="(item,index) in pop_ques_list" :key="index" @click="getPopIndex(item)">
                <div >{{item.title}}</div>
              </li>
            </ul>
          </div>
        </div>
        <div class="com_question">
          <div class="title">常见问题</div>
          <div class="com_list">
            <ul id="ul">
              <li v-for="(item,index) in com_que" :key="item.id" @click="getComIndex(item.id,index)">
                <div>
                  <img :src="item.imgSrc" alt=""/>
                  <p>{{item.content}}</p>
                  <img :src="item.sjxSrc" alt="" class="img"/>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="question_list">
      <div class="inner">
        <ul>
          <li v-for="(item,index) in com_ques_list" :key="index" @click="getListIndex(item.id,index)">
            <div>
              <span>{{item.title}}？</span><span>
              <img src="../assets/images/arrow.png" alt=""/></span>
            </div>
          </li>
        </ul>
        <div class="online_service">
          <a href="tel:0551-64935899"><img src="../assets/images/online_custom.png" alt=""/>在线客服</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "MyService",
    data:function(){
      return {
        uid: '',
        //热门问题列表
        pop_ques_list:[],
        //常见问题
        com_que:[
          {
            imgSrc:require('../assets/images/custom_service_account.png'),
            content:'账户问题',
            sjxSrc:require('../assets/images/kuaigui_wode_sanjiaoxing.png')
          },
          {
            imgSrc:require('../assets/images/custom_service_carsocket.png'),
            content:'车锁使用',
            sjxSrc:require('../assets/images/kuaigui_wode_sanjiaoxing.png')
          },
          {
            imgSrc:require('../assets/images/custom_service_discount.png'),
            content:'优惠活动',
            sjxSrc:require('../assets/images/kuaigui_wode_sanjiaoxing.png')
          },
          {
            imgSrc:require('../assets/images/custom_service_order.png'),
            content:'订单问题',
            sjxSrc:require('../assets/images/kuaigui_wode_sanjiaoxing.png')
          }
        ],
        //常见问题列表
        com_ques_list:[],
        //记录点击常见问题时的下标---用于更新常见问题内容
        comIndex:0,
        //记录点击常见问题时候的问题分类
        items:10,
        //记录点击热门问题时候的id
        popId:null,
        //点击常见问题跳转到详情时带的id---后台传来的
        problemId:null,
        //常见问题列表的分页
        currentPage:null,
      }
    },
    mounted:function(){
      this.uid = this.$route.query.uid;
      //页面加载完成时调取我的客服页面数据---热门问题列表+常见问题列表
      this.getMyService();

      // 箭头显示隐藏start
      let imgs=document.getElementsByClassName('img');
      for(let i=0;i<imgs.length;i++){
        imgs[i].style.display="none"
      }
      imgs[0].style.display="block"
      //箭头显示隐藏end
    },
    methods:{
      //进入页面获取我的客服页面常用问题和热门问题数据
      getMyService:function(){
        this.$ajax.post('/problem/list',{
            //问题分类
            items:this.items,
            //常见问题分页的当前页
            currentPage:this.currentPage,
            //用户基本数据
            base:{
              uid:this.uid,
            }
        }).then(res=>{
          window.console.log(res);
          //记得加this!
          this.pop_ques_list=res.data.data.hotProblemList;
          // console.log(this.pop_ques_list)
          this.com_ques_list=res.data.data.normalProblemList;
          // console.log(this.com_ques_list)
        }).catch(err=>{
          window.console.log(err);
        })
      },
      //点击常见问题某个按钮获取某个页面的数据
      getComIndex:function(id,index){
        //index为当前点击的li的下标
        // console.log(index)
        //把当前点击的li的下标赋值给全局的index
        this.comIndex=index;
        switch(this.comIndex){
          //账户问题
          case 0:this.items=10;break;
          //车锁使用问题
          case 1:this.items=11;break;
          //优惠活动问题
          case 2:this.items=12;break;
          //订单问题
          case 3:this.items=13;
        }
        window.console.log(this.items);
        //箭头显示隐藏start
        let imgs=document.getElementsByClassName('img');
        for(let i=0;i<imgs.length;i++){
          imgs[i].style.display='none'
        }
        imgs[this.comIndex].style.display="block";
        //箭头显示隐藏end
        this.getMyService();
      },
      //点击任一热门问题进入到详情页面
      getPopIndex:function(item){
        // console.log(id)
        this.popId=item.id;
        window.console.log(this.popId);
        this.$router.push({
          path: `/questionDetail/${item.id}`,
        });
      },
      //点击常见问题下的列表更改problemId----方便跳转传值
      getListIndex:function(id,index){
        // console.log(id)
        this.problemId=id;
        this.currentPage=index;
        window.console.log(this.problemId);
        window.console.log(this.currentPage);
        this.$router.push({
          path: `/questionDetail/${this.problemId}`,
        });
      },
    }
  }
</script>

<style lang="scss" type="text/scss">
  .myService{
    width: 100vw;
    height: 100vh;
    overflow: auto;
    img{
      display: block;
    }
    .main{
      width: 100%;
      background: #fff;
      padding-top: 6.666667vw;
      box-shadow: 2px 2px 2px 2px rgba(0,0,0,0.1);
      z-index: 99;
      margin-bottom: 1vw;
      position: relative;
      padding-bottom: 5vw;
    }

    .question{
      width: 94%;
      margin: 0 auto;
    }

    .pop_question>.title{
      font-size: 6vw;
      font-weight: bold;
    }

    .pop_question .pop_list{
      display: flex;
      flex-direction: column;
      margin-top: 6.666667vw;
    }

    .pop_list ul li{
      display: inline-block;
      border: 1px solid #eee;
      border-radius: 5.333333vw;
      color: #666;
      padding: 3vw;
      font-weight: normal;
      margin-right: 2vw;
      margin-bottom: 3vw;
    }

    .com_question .title{
      font-size: 6vw;
      font-weight: bold;
      margin-top: 5vw;
    }

    .com_list ul li img:first-child{
      width: 12vw;
    }

    .com_list ul li img:last-child{
      width: 5vw;
      /* background: #f00; */
      position: absolute;
      bottom: -5vw;
      left: 50%;
      margin-left: -1.333333vw;
    }

    .com_list ul{
      display: flex;
      margin-top: 6.666667vw;
    }

    .com_list ul li{
      width: 25%;
      font-size: 3.6vw;
      font-weight: normal;
      position: relative;
    }

    .com_list ul li p{
      margin-top: 2.666667vw;
    }

    .com_list ul li div{
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .question_list{
      width: 100%;
      background: #fff;
    }
    .question_list .inner{
      width: 94%;
      margin: 0 auto;
    }

    .question_list ul li{
      border-bottom: 0.133333vw solid #eee;
      font-weight: 550;
    }

    .question_list ul li div{
      height: 16vw;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .question_list .inner ul li span img{
      width: 1.5vw;
    }

    .online_service img{
      width: 4vw;
      margin-right: 1vw;
    }

    .online_service a{
      display: flex;
      font-size: 3vw;
      background: #fff;
      width: 26vw;
      height: 10vw;
      align-items: center;
      justify-content: center;
      border-radius: 5vw;
      box-shadow: 0 0 1.5vw 1vw rgba(0,0,0,0.05);
    }
    .online_service{
      position: fixed;
      right: 4vw;
      bottom: 15vw;
    }
  }
</style>